<!-- This code is a copy from original VFETL => MEC => HERE. -->
<template>
    <div id="geomap">
        <v-container v-if="noData" style="position: absolute">
            No Data
        </v-container>

        <v-expansion-panels style="position: absolute; z-index: 7; bottom: 0">
            <v-expansion-panel>
                <v-expansion-panel-header color="actions">
                    <span class="actionsText--text" style="font-size: 13px;">Map Layers</span>
                    <template v-slot:actions>
                        <v-icon color="actionsText">
                            mdi-chevron-up
                        </v-icon>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content style="padding-top: 28px;">
                    <v-layout row v-if="this.geo.toggleNoDetects" style="padding-bottom: 8px;">
                        <v-flex xs1>
                            <v-checkbox label=" " color="noDetect" v-model="no_detects_selected" class="selectionBoxes">
                            </v-checkbox>
                        </v-flex>
                        <v-flex xs5 style="padding-top:1px; padding-left:5px"><span style="font-size: 9pt;">No
                                detect</span></v-flex>
                        <v-flex xs4 style="padding-top:1px;"><span style="font-size: 9pt;">RQ = 0</span></v-flex>
                        <v-flex xs2 style="padding-top:1px;"><span
                                style="font-size: 9pt; float:right;">({{num_no_detects}})</span></v-flex>
                    </v-layout>

                    <v-layout row style="padding-bottom: 8px;">
                        <v-flex xs1>
                            <v-checkbox label=" " color="insignificant" v-model="insignificant_risk_selected"
                                class="selectionBoxes"></v-checkbox>
                        </v-flex>
                        <v-flex xs5 style="padding-top:1px; padding-left:5px"><span style="font-size: 9pt">Insignificant
                                risk</span></v-flex>
                        <v-flex xs4 style="padding-top:1px;"><span style="font-size: 9pt;">0 &lt; RQ &lt;= 0.1</span>
                        </v-flex>
                        <v-flex xs2 style="padding-top:1px;"><span
                                style="font-size: 9pt; float:right;">({{num_insignificant_risk}})</span>
                        </v-flex>
                    </v-layout>

                    <v-layout row style="padding-bottom: 8px;">
                        <v-flex xs1>
                            <v-checkbox label=" " color="low" v-model="low_risk_selected" class="selectionBoxes">
                            </v-checkbox>
                        </v-flex>
                        <v-flex xs5 style="padding-top:1px; padding-left:5px"><span style="font-size: 9pt">Low
                                risk</span></v-flex>
                        <v-flex xs4 style="padding-top:1px;"><span style="font-size: 9pt;">0.1 &lt; RQ &lt;= 1</span>
                        </v-flex>
                        <v-flex xs2 style="padding-top:1px;"><span
                                style="font-size: 9pt; float:right;">({{num_low_risk}})</span></v-flex>
                    </v-layout>

                    <v-layout row style="padding-bottom: 8px;">
                        <v-flex xs1>
                            <v-checkbox label=" " color="med" v-model="moderate_risk_selected" class="selectionBoxes">
                            </v-checkbox>
                        </v-flex>
                        <v-flex xs5 style="padding-top:1px; padding-left:5px"><span style="font-size: 9pt">Moderate
                                risk</span></v-flex>
                        <v-flex xs4 style="padding-top:1px;"><span style="font-size: 9pt;">1 &lt; RQ &lt;= 10</span>
                        </v-flex>
                        <v-flex xs2 style="padding-top:1px;"><span
                                style="font-size: 9pt; float:right;">({{num_moderate_risk}})</span></v-flex>
                    </v-layout>

                    <v-layout row style="padding-bottom: 10px;">
                        <v-flex xs1>
                            <v-checkbox label=" " color="high" v-model="high_risk_selected" class="selectionBoxes">
                            </v-checkbox>
                        </v-flex>
                        <v-flex xs5 style="padding-top:1px; padding-left:5px"><span style="font-size: 9pt">High
                                risk</span></v-flex>
                        <v-flex xs4 style="padding-top:1px;"><span style="font-size: 9pt;">RQ &gt; 10</span>
                        </v-flex>
                        <v-flex xs2 style="padding-top:1px;"><span
                                style="font-size: 9pt; float:right;">({{num_high_risk}})</span></v-flex>
                    </v-layout>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div id="mec-map-container" class="grid-item" :style="{height: height}" style="min-height:200px">
            <gmOverlay v-if="$vuetify.breakpoint.mdAndUp" :data="overlayData"></gmOverlay>
        </div>

        <v-dialog v-model="pointDialog" :fullscreen="$vuetify.breakpoint.width<312" scrollable max-width="800">
            <v-card>
                <v-card-title class="primary white--text" style="font-family: Orkney !important;">
                    Data at Region
                    <v-spacer></v-spacer>
                    <v-btn icon large dark @click.stop="pointDialog=false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="padding:0">
                    <v-data-iterator :items="pointData" :items-per-page.sync="itemsPerPage" :page.sync="page" hide-default-footer
                                     @update:items-per-page="updateItemsPerPage">
                        <template v-slot:default="props">
                            <v-expansion-panels v-model="dataExpanded" tile>
                                <v-expansion-panel v-for="(item,i) in props.items" :key="i">
                                    <v-expansion-panel-header>
                                        <template v-slot:actions>
                                            <v-icon :color="getClusterColorFromRQ(item['rq'])" class="mx-2">mdi-circle</v-icon>
                                            <v-icon>mdi-chevron-down</v-icon>
                                        </template>
                                        {{i+pageOffset}}:&nbsp;
                                        <template v-if="item['p'] || item['c']">
                                            {{item['p']}}<span v-if="item['p'] && item['c']" style="display: contents;">,</span>&nbsp;
                                            <template v-if="item['c']==='multiple'">
                                                <span class="ml-1" style="font-style: italic;">(Multiple Regions)</span>
                                            </template>
                                            <template v-else>
                                                {{item['c']}}
                                            </template>
                                        </template>
                                        <template v-else>
                                            <span class="ml-1" style="font-style: italic;">(No region specified)</span>
                                        </template>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div><span style="font-weight: bold">Coordinates: </span>
                                            <template v-if="item['y'] && item['x']">{{item['y']}} N, {{item['x']}} E</template>
                                            <template v-else>0 N, 0 E</template></div>
                                        <div><span style="font-weight: bold">Measurement: </span>{{item['s']}}</div>
                                        <div><span style="font-weight: bold">Compartment:
                                            </span>{{item['e']}}</div>
                                        <div><span style="font-weight: bold">RQ: </span>{{item['rq'].toPrecision(5)}}</div>
                                        <div><span style="font-weight: bold">Citation: </span> {{constructCitation(item)}}
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </template>
                    </v-data-iterator>
                </v-card-text>
                <v-card-actions class="pa-0">
                    <v-container class="d-flex justify-space-between px-2">
                        <div class="ml-4 d-flex">
                            <span class="grey--text align-self-center">Items per page:</span>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                <v-btn dark text color="primary" class="ml-1 align-self-center" width="50" v-bind="attrs" v-on="on">
                                    {{ itemsPerPage }}
                                    <v-icon>mdi-chevron-down</v-icon>
                                </v-btn>
                                </template>
                                <v-list>
                                <v-list-item v-for="(number, index) in itemsPerPageArray" :key="index" @click="updateItemsPerPage(number)">
                                    <!-- FIXME: Padding hack, differs from localhost and build. -->
                                    <v-list-item-title class="px-4">{{ number }}</v-list-item-title>
                                </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                        <div class="ml-4 d-flex">
                            <span class="grey--text align-self-center mr-1">
                                Page {{ page }} of {{ numberOfPages }}
                            </span>
                            <v-btn dark icon small color="primary" class="mr-1 align-self-center" @click="formerPage">
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn dark icon small color="primary" class="ml-1 mr-2 align-self-center" @click="nextPage">
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {
        Map,
        View,
        Feature
    } from 'ol'
    import {
        fromLonLat
    } from 'ol/proj.js'
    import {
        Style,
        Circle,
        Fill,
        Stroke
    } from 'ol/style'
    import Point from 'ol/geom/Point'
    import TileLayer from 'ol/layer/Tile'
    import VectorLayer from 'ol/layer/Vector'
    import VectorSource from 'ol/source/Vector'
    import Cluster from 'ol/source/Cluster'
    import OSM from 'ol/source/OSM'
    import {
        createEmpty,
        extend
    } from 'ol/extent'
    import { colors } from '../../../plugins/vuetify.ts'
    import raw from '../../../ts/raw.json'
    import gmOverlay from './gmOverlay.vue'

    export default {
        components: {
            gmOverlay
        },
        props: {
            geo: {
                required: true
            },
            height: {
                required: false,
                default: "300px"
            },
            toggleNoDetects: {
                type: Boolean,
                default: false
            },
            reset: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                noData: false,

                // Map data
                panel: [],
                pointData: [], // last point to be clicked on
                pointDialog: false,
                listSelection: null,
                mec_map: null, // the OS map object

                no_detects_layer: null, // vector layers for markers at different risk levels
                insignificant_risk_layer: null,
                low_risk_layer: null,
                moderate_risk_layer: null,
                high_risk_layer: null,

                no_detects_selected: true, // which checkboxes are selected
                insignificant_risk_selected: true,
                low_risk_selected: true,
                moderate_risk_selected: true,
                high_risk_selected: true,

                style_cache: { // cache of openlayers style objects for map points
                    [colors.noDetect]: {},
                    [colors.insignificant]: {},
                    [colors.low]: {},
                    [colors.med]: {},
                    [colors.high]: {},
                },

                cluster_distance: 15, // distance in pixels of map points to be aggregated into the same cluster, this is not the same as the size of the circle!
                num_no_detects: 0, // the number of points in each risk level
                num_insignificant_risk: 0,
                num_low_risk: 0,
                num_moderate_risk: 0,
                num_high_risk: 0,

                dataExpanded: null,
                overlayData: [],
                mapCurrentlyMoving: false,
                itemsPerPage: 5,
                itemsPerPageArray: [5, 10, 25, 50, 100],
                page: 1,
            }
        },
        computed: {
            numberOfPages() {
                return Math.ceil(this.pointData.length / this.itemsPerPage)
            },
            pageOffset() {
                if (this.page === 0) {
                    return 1
                }
                else {
                    return ((this.page - 1) * this.itemsPerPage) + 1
                }
            }
        },
        watch: {
            no_detects_selected() {
                this.refresh_map_layers()
            },
            insignificant_risk_selected() {
                this.refresh_map_layers()
            },
            low_risk_selected() {
                this.refresh_map_layers()
            },
            moderate_risk_selected() {
                this.refresh_map_layers()
            },
            high_risk_selected() {
                this.refresh_map_layers()
            },
            toggleNoDetects() {
                this.toggle_on_all_map_layers()
            },
            reset() {
                this.toggle_on_all_map_layers()               
            }
        },
        mounted() {
            this.create_map()
            this.refresh_map()
        },
        methods: {
            nextPage() {
                if (this.page + 1 <= this.numberOfPages) this.page += 1
                this.dataExpanded = null
            },
            formerPage() {
                if (this.page - 1 >= 1) this.page -= 1
                this.dataExpanded = null
            },
            updateItemsPerPage(evt) {
                this.itemsPerPage = evt
                this.dataExpanded = null
            },
            updateChartData() {
                // TODO:
                // noData = is_there_Data??
            },

            /**
             * Caches openlayers style objects
             * @param colour
             * @param cluster
             * @return
             */
            get_map_feature_style: function (colour, cluster) {

                // Compute size of point
                const num_points = cluster.get('features')
                    .map((feature) => feature.get('measurement_info').length)
                    .reduce((a, b) => a + b, 0)
                const size = Math.max(7, Math.min(this.cluster_distance, num_points))
                // Update cache if necessary
                if (!(size in this.style_cache[colour])) {
                    this.style_cache[colour][size] = new Style({
                        image: new Circle({
                            radius: size,
                            stroke: new Stroke({
                                color: colors.mulberry,
                                width: 0
                            }),
                            fill: new Fill({
                                color: colour
                            }),
                        }),
                    })
                }
                // Return style from cache
                return this.style_cache[colour][size]
            },

            /**
             * Initialise the map data structures.
             * NB: Only call this method once
             */
            create_map: function () {
                // Create vector layers for map points
                this.no_detects_layer = new VectorLayer({
                    source: new Cluster({
                        distance: this.cluster_distance,
                        source: new VectorSource({
                            features: [],
                        }),
                    }),
                    style: (cluster) => {
                        return this.get_map_feature_style(colors.noDetect, cluster)
                    },
                })
                this.insignificant_risk_layer = new VectorLayer({
                    source: new Cluster({
                        distance: this.cluster_distance,
                        source: new VectorSource({
                            features: [],
                        }),
                    }),
                    style: (cluster) => {
                        return this.get_map_feature_style(colors.insignificant, cluster)
                    },
                })
                this.low_risk_layer = new VectorLayer({
                    source: new Cluster({
                        distance: this.cluster_distance,
                        source: new VectorSource({
                            features: [],
                        }),
                    }),
                    style: (cluster) => {
                        return this.get_map_feature_style(colors.low, cluster)
                    },
                })
                this.moderate_risk_layer = new VectorLayer({
                    source: new Cluster({
                        distance: this.cluster_distance,
                        source: new VectorSource({
                            features: [],
                        }),
                    }),
                    style: (cluster) => {
                        return this.get_map_feature_style(colors.med, cluster)
                    },
                })
                this.high_risk_layer = new VectorLayer({
                    source: new Cluster({
                        distance: this.cluster_distance,
                        source: new VectorSource({
                            features: [],
                        }),
                    }),
                    style: (cluster) => {
                        return this.get_map_feature_style(colors.high, cluster)
                    },
                })

                this.mec_map = new Map({
                    target: 'mec-map-container',
                    layers: [
                        // Map image
                        new TileLayer({
                            source: new OSM()
                        }),
                        // Vector layers for points
                        this.high_risk_layer,
                        this.moderate_risk_layer,
                        this.low_risk_layer,
                        this.insignificant_risk_layer,
                        this.no_detects_layer,
                    ],
                    view: new View({
                        // TODO: Work out how to choose which projection we use (the below make it crash)
                        // projection: ol.proj.get('EPSG:4326'),
                        // projection: 'EPSG:3785',
                        // projection: 'EPSG:3857',

                        // TODO: Centre & zoom map to show all the points
                        center: fromLonLat([0, 38]),
                        zoom: 2,
                        minZoom: 2,
                        maxZoom: 20,
                        enableRotation: false
                    })
                });

                // When user clicks on a MEC point, update the data in Vue
                this.mec_map.on('singleclick', (evt) => {
                    const clusters = this.mec_map.getFeaturesAtPixel(evt.pixel)

                    if (clusters) {
                        for (const cluster of clusters) {
                            const features = cluster.get('features')
                            this.pointData = []
                            this.panel = []

                            this.$nextTick(() => {

                                if (features.length === 1) {
                                    this.panel = 0
                                }

                                for (const feature of features) {
                                    this.pointData.push(...feature.get('measurement_info'))
                                }
                                // Sort points based on their location & country (how they appear in the dialog)
                                this.pointData.sort((a, b) => `${a['p']} ${a['c']}` > `${b['p']} ${b['c']}` ? 1 : -1)
                                this.dataExpanded = null
                                this.pointDialog = true
                            })
                        }
                    }
                });

                this.mec_map.on('pointermove', (evt) => {
                    this.overlayData = []
                    const clusters = this.mec_map.getFeaturesAtPixel(evt.pixel)

                    if (clusters && !this.mapCurrentlyMoving) {
                        for (const cluster of clusters) {
                            let featuresAtCluster = cluster.get('features')
                            for (const feature of featuresAtCluster) {
                                this.overlayData.push(feature.get('measurement_info'))
                            }
                        }
                    }
                });

                // Prevent overlay from displaying data if the map is currently moving
                this.mec_map.on('movestart', () => {
                    this.overlayData = []
                    this.mapCurrentlyMoving = true
                });
                this.mec_map.on('moveend', () => {
                    this.mapCurrentlyMoving = false
                });
            },

            /**
             * Add data to the map, and respond to user inputs
             */
            refresh_map: function () {
                this.$emit('loading')
                //TODO: code smell. refactor.
                // This needs to wait for "loading" states to trigger
                // before kicking off this massive render.
                setTimeout(this.refresh_map_actual, 50);
            },


            refresh_map_actual: function () {
                this.$emit('loading')
                // Check that we have a map to refresh
                // if (!this.data_ready) {
                // 	return
                // }

                // Create the points for the MEC measurements
                this.no_detects_layer.getSource().getSource().clear()
                this.insignificant_risk_layer.getSource().getSource().clear()
                this.low_risk_layer.getSource().getSource().clear()
                this.moderate_risk_layer.getSource().getSource().clear()
                this.high_risk_layer.getSource().getSource().clear()
                this.num_no_detects = 0
                this.num_insignificant_risk = 0
                this.num_low_risk = 0
                this.num_moderate_risk = 0
                this.num_high_risk = 0

                const no_detects_features = []
                const insignificant_risk_features = []
                const low_risk_features = []
                const moderate_risk_features = []
                const high_risk_features = []

                let point_groups = {}  // cache for points that overlap completely

                for (const map_point of this.geo.data) {
                    // Wrap coordinates to [-90, 90] for northings, and [-180, 180] for eastings
                    let lon = this.mod(map_point['x'], 360)
                    if (lon > 180) {
                        lon -= 360
                    }
                    let lat = this.mod(map_point['y'], 180)
                    if (lat > 90) {
                        lat -= 180
                    }

                    // Decide which layer to add point to
                    let array_for_point = undefined
                    let layer_key = ''
                    if (map_point['rq'] === 0.0) {
                        array_for_point = no_detects_features
                        layer_key = 'no_detect'
                        this.num_no_detects += 1
                    } else if (map_point['rq'] <= 0.1) {
                        array_for_point = insignificant_risk_features
                        layer_key = 'insignificant_risk'
                        this.num_insignificant_risk += 1
                    } else if (map_point['rq'] <= 1.0) {
                        array_for_point = low_risk_features
                        layer_key = 'low_risk'
                        this.num_low_risk += 1
                    } else if (map_point['rq'] <= 10.0) {
                        array_for_point = moderate_risk_features
                        layer_key = 'moderate_risk'
                        this.num_moderate_risk += 1
                    } else {
                        array_for_point = high_risk_features
                        layer_key = 'high_risk'
                        this.num_high_risk += 1
                    }

                    // Add point to the map, grouping together points that overlap completely (same layer and coordinates)
                    const point_group_key = `${lon}-${lat}-${layer_key}`
                    if (Object.prototype.hasOwnProperty.call(point_groups, point_group_key)) {
                        // Reuse point created previously
                        point_groups[point_group_key].get('measurement_info').push(map_point)
                    }
                    else {
                        // Create a new point
                        const feature = new Feature({
                            geometry: new Point(fromLonLat([lon, lat])),
                            measurement_info: [map_point],
                            country: map_point['c'],
                            substance: map_point['s'],
                            rq: map_point['rq'].toPrecision(5),
                            site: map_point['p'],
                        })
                        point_groups[point_group_key] = feature
                        array_for_point.push(feature)
                    }
                }
                this.no_detects_layer.getSource().getSource().addFeatures(no_detects_features)
                this.insignificant_risk_layer.getSource().getSource().addFeatures(insignificant_risk_features)
                this.low_risk_layer.getSource().getSource().addFeatures(low_risk_features)
                this.moderate_risk_layer.getSource().getSource().addFeatures(moderate_risk_features)
                this.high_risk_layer.getSource().getSource().addFeatures(high_risk_features)

                // Zoom map to data
                let extent = createEmpty()
                for (const layer of [this.no_detects_layer, this.insignificant_risk_layer, this.low_risk_layer, this.moderate_risk_layer,
                this.high_risk_layer
                ]) {
                    extent = extend(extent, layer.getSource().getSource().getExtent())
                }
                if (extent[0] !== Infinity) { // Don't call fit() on an empty extent: crashes openlayers!

                    this.mec_map.getView().setCenter(fromLonLat([0, 38]))
                    this.mec_map.getView().setZoom(2)

                    // Remove the auto finding algorithm below:
                    // this.mec_map.getView().fit(extent, {
                    //     maxZoom: 5
                    // })
                }

                // Refresh map
                this.mec_map.updateSize()

                this.$nextTick(() => {
                    this.$emit("loaded")
                })
            },
            refresh_map_layers: function () {
                // Set visibility of layers based on user input checkboxes
                this.no_detects_layer.setVisible(this.no_detects_selected)
                this.insignificant_risk_layer.setVisible(this.insignificant_risk_selected)
                this.low_risk_layer.setVisible(this.low_risk_selected)
                this.moderate_risk_layer.setVisible(this.moderate_risk_selected)
                this.high_risk_layer.setVisible(this.high_risk_selected)

                // Refresh map
                this.mec_map.updateSize()
            },
            toggle_on_all_map_layers: function () {
                // Make all layers & checkboxes visible
                this.no_detects_layer.setVisible(this.no_detects_selected = true)
                this.insignificant_risk_layer.setVisible(this.insignificant_risk_selected = true)
                this.low_risk_layer.setVisible(this.low_risk_selected = true)
                this.moderate_risk_layer.setVisible(this.moderate_risk_selected = true)
                this.high_risk_layer.setVisible(this.high_risk_selected = true)   
            },
            mod(x, m) {
                return (x % m + m) % m;
            },
            constructCitation(item) {
                return raw.mecsAuthors[item.a] + " " + raw.mecsTitles[item.t] + " " + raw.mecsCitations[item.n] + " "
            },
            getClusterColorFromRQ(rq) {
                let color = ''
                if (rq === 0) {
                    color = colors.noDetect
                }
                else if (rq <= 0.1) {
                    color = colors.insignificant
                }
                else if (rq <= 1.0) {
                    color = colors.low
                }
                else if (rq <= 10.0) {
                    color = colors.med
                }
                else {
                    color = colors.high
                }
                return color
            }
        }
    }
</script>

<style>
    #geomap .ol-overlaycontainer {
        display: none
    }

    #geomap .ol-overlaycontainer-stopevent {
        display: none
    }

    #geomap .selectionBoxes {
        margin: 0;
        padding: 0;
        height: 0;
    }

    #geomap .v-expansion-panel::before {
        box-shadow: none !important;
    }

    #geomap .v-expansion-panel-header {
        height: 48px !important;
        min-height: 48px !important;
    }
</style>